import { render } from "./myFooter.vue?vue&type=template&id=2638f1c2&scoped=true"
import script from "./script.js?vue&type=script&lang=js"
export * from "./script.js?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=2638f1c2&scoped=true&lang=scss"

import exportComponent from "/builds/development-team/front-end/acgnn-sports/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2638f1c2"]])

export default __exports__